<template>
  <div class="general-container grey-background">
    <the-navbar />
    <project
      v-if="!isLoading"
      :activity-identifier="activityIdentifier"
      :show-filter="false"
    />
    <b-loading
      v-model="isLoading"
      :is-full-page="true"
      :can-cancel="false"
      class="fill-screen"
    />
  </div>
</template>

<script>
import Project from '@/components/interactions/Project.vue'
import TheNavbar from '@/components/TheNavbar.vue'

export default {
  name: 'ProjectInteractions',
  components: {
    Project,
    TheNavbar
  },

  data() {
    return {
      isLoading: true
    }
  },

  computed: {
    activityIdentifier() {
      return this.$route.params.activityIdentifier
    },

    projectIdentifier() {
      return this.$route.params.projectIdentifier
    }
  },

  async created() {
    // Fetch the Project data
    const params = {
      projectIdentifier: this.projectIdentifier
    }

    await this.$store.dispatch('interactionsInteractions/getTaskListData', params)

    this.isLoading = false
  }
}
</script>
